<template>
  <v-container fluid>
    <v-row>
      <div class='header'>
        <h2>Все образцы вида</h2>
      </div>

      <div class='horizontal-rule' />

      <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    </v-row>
    <v-row class='mt-5'>
      <v-col
        v-for='(item, index) in plants'
        :key='index'
        sm='4'
        class="fill-height"
      >
        <router-link :to="'/collections/' + `${item.id}`">
          <v-card
            class='mb-4'
            max-width='374'
            tile
          >
            <v-img
              :src="exhibitCompressedPhotoPath + `/${item.photos[0].compressedPhotoPath}`"
            ></v-img>

            <v-list-item three-line>
              <v-list-item-content>
                <v-card elevation="1" class='rounded-0'>
                  <v-card-title class="pa-0 ma-0">Штрихкод</v-card-title>
                  <v-card-text class="pa-0 ma-0">{{ item.barcode }}</v-card-text>
                </v-card>

                <v-card elevation="1" class='rounded-0' v-if="item.labelName">
                  <v-card-title class="pa-0 ma-0">Название на этикетке</v-card-title>
                  <v-card-text class="pa-0 ma-0">{{ item.labelName }}</v-card-text>
                </v-card>

                <v-card elevation="1" class='rounded-0' v-if="item.taxonomy">
                  <v-card-title class="pa-0 ma-0">Название по Catalogue of Life</v-card-title>
                  <v-card-text class="pa-0 ma-0">{{ item.taxonomy }}</v-card-text>
                </v-card>

                <v-card elevation="1" class='rounded-0' v-if="item.gatheringPlaceCountry || item.gatheringPlaceDistrict || item.gatheringPlaceRegion">
                  <v-card-title class="pa-0 ma-0">Место сбора</v-card-title>

                  <v-card-text v-if="item.gatheringPlaceCountry" class="pa-0 ma-0">
                    {{ "Cтрана сбора: " + item.gatheringPlaceCountry}}
                  </v-card-text>

                  <v-card-text v-if="item.gatheringPlaceRegion" class="pa-0 ma-0">
                    {{ "Республика/область сбора: " + item.gatheringPlaceRegion}}
                  </v-card-text>

                  <v-card-text v-if="item.gatheringPlaceDistrict" class="pa-0 ma-0 pb-1">
                    {{ "Район сбора: " + item.gatheringPlaceDistrict}}
                  </v-card-text>
                </v-card>

              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>
    </v-row>

    <v-container v-if="!isLoading">
      <v-row class="justify-start">
        <v-pagination
            v-model="page"
            :length="maxPage + 1"
            :total-visible="7"
        ></v-pagination>
      </v-row>
    </v-container>

  </v-container>
</template>

<script>
import {fetchAllExhibits} from "@/services/exhibitAPI";
import {exhibitCompressedPhotoPath} from "@/helpers/siteURL";
import LoadingModal from "@/components/UI/LoadingModal";

export default {
  name: 'AllExhibitPage',
  components: { LoadingModal },

  data: () => ({
    isLoading: false,
    selection: 1,
    exhibitCompressedPhotoPath: exhibitCompressedPhotoPath,

    page: 1,
    maxPage: 0,

    plants: []
  }),

  watch: {
    async page() {
      this.isLoading = true
      await fetchAllExhibits(this.$route.params.species, this.page - 1)
          .then((data) => {
            this.plants = data.body
            this.maxPage = data.maxPage
          }).finally(() => this.isLoading = false)
    }
  },

  async created() {
    this.isLoading = true
    await fetchAllExhibits(this.$route.params.species, this.page - 1)
        .then((data) => {
          this.plants = data.body
          this.maxPage = data.maxPage
        }).finally(() => this.isLoading = false)
  }
};
</script>

<style scoped>

</style>